import { Flex } from '@ironhack/design-system2/components/flex';
import { Icon } from '@ironhack/design-system2/components/icon';
import { Text } from '@ironhack/design-system2/components/text';
import { VStack } from '@ironhack/design-system2/components/stack';
import { ChevronRight } from '@ironhack/design-system2/icons/chevron-right';
import { Link as LinkIcon } from '@ironhack/design-system2/icons/link';
import { type ReactElement } from 'react';

import { Link } from '@/app/components/client/link';
import { type DatoLinkBlock } from '@/lib/datocms';

type FooterColumnProps = {
  title: string;
  links: DatoLinkBlock[];
  noFollow?: boolean;
};

const iconMap = {
  'chevron-right': ChevronRight,
  link: LinkIcon,
} as const;

export const FooterColumn = (props: FooterColumnProps): ReactElement => {
  const { title, links, noFollow } = props;
  return (
    <Flex direction="column">
      <Text textStyle="2xl">{title}</Text>
      <VStack alignItems="flex-start" mt={3} spacing={2}>
        {links.map((link) => {
          const IconComponent =
            iconMap[link.icon?.[0]?.name as keyof typeof iconMap];
          const target = link.target[0];
          const tracking =
            target.route?.page?.__typename === 'ContactFormPageRecord'
              ? { f: 'fc' }
              : {};
          return (
            <Link
              _hover={{
                color: 'link.inverse',
                textDecoration: 'underline',
              }}
              color="link.inverse"
              key={link.text}
              {...(noFollow && { rel: 'nofollow' })}
              tracking={tracking}
              w="full"
              {...target}
            >
              <Flex justify="space-between" w={['100%', null, '250px']}>
                {link.text}
                {IconComponent && (
                  <Icon
                    as={IconComponent}
                    boxSize="24px"
                    color="text.inverse"
                  />
                )}
              </Flex>
            </Link>
          );
        })}
      </VStack>
    </Flex>
  );
};
